<template>
    <template v-if="$store.state.config?.modules?.login === 'user'">
        <FormUser />
    </template>
    <template v-else>
        <FormTerminal />
    </template>
</template>
<script>
import FormTerminal from '@/components/login/terminalId/index.vue'
import FormUser from '@/components/login/userId/index.vue'

export default {
    components: { FormTerminal, FormUser },
};
</script>

<style lang="scss">
@import "@/public/scss/login.scss";
</style>
